export const OUTLOOK_FAVORITES_API_URL: string = "ows/api/beta/outlookfavorites";
